import request from '../helpers/request';

const getRequest = async (requestId, errMsg) => {
  return await request.get(
    `/Request`,
    { requestId },
    errMsg || `При загрузке заявки произошла ошибка`,
    []
  );
};

export default getRequest;
